// Loghi degli sponsor ufficiali.
// I file vanno in /app/frontend/public/sponsor/
// link facoltativo: se presente il logo diventa cliccabile.
export const SPONSORS = [
  { name: "Bartoccini Gioielleria dal 1964", img: "/sponsor/bartoccini-gioiellerie.png", link: "https://www.bartoccini.it", h: "h-20 md:h-28" },
  { name: "F.lli Palomba – Honda Rental Royal", img: "/sponsor/palomba-honda.png", link: "https://fratellipalomba.it/", h: "h-10 md:h-14" },
];
